// extracted by mini-css-extract-plugin
export var cardIcon = "_v-5";
export var cardIconUnframed = "_v-9";
export var checkboxCard = "_v-0";
export var checkboxCardSelected = "_v-4";
export var disabled = "_v-2";
export var interactive = "_v-1";
export var outerBorder = "_v-3";
export var spacerMedium = "_v-8";
export var spacerSmall = "_v-7";
export var spacerXsmall = "_v-6";